module.exports = __webpack_public_path__ + "static/img/member_list_4.81396a3e.png";